import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { BrandModel } from '../model/index';

@Injectable()
export class BrandService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private brandUrl = 'api/brand';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getBrandList(query: any): Promise<BrandModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.brandUrl}/brandList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    // getBrand(brand_id: number): Promise<BrandModel> {
    //     const url = `${this.brandUrl}/brandList?brand_id=${brand_id}`;
    //     return this.http.get(url)
    //         .toPromise()
    //         .then(response => response.json().data as BrandModel)
    //         .catch(this.handleError);
    // }

    deleteBrand(brand_id: any): Promise<BrandModel> {
        const url = `${this.brandUrl}/deleteBrand`;
        return this.http
            .post(url, $.param({ brand_id: brand_id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as BrandModel)
            .catch(this.handleError);
    }

    addUpdateBrand(brandData: any): Promise<BrandModel> {

        const url = `${this.brandUrl}/addUpdateBrand`;

        return this.http
            .post(url, $.param(brandData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as BrandModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/brand.service.ts